// extracted by mini-css-extract-plugin
export default {"wrapper":"button-text_wrapper__CW2UF"};